import * as React from 'react';
import { SVGProps } from 'react';

const IconTrashSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3v1h-1v7a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3H1V2h3zm1 2H4v5h1V4zm3 0H7v5h1V4z"
    />
  </svg>
);
export default IconTrashSizeXs;
